import { useThemeContext } from "@/react/providers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Icon } from "@circle-react-shared/Icon";
import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface CourseItemProps {
  isDragOverlay?: boolean;
}

export const CourseItem = ({ isDragOverlay = false }: CourseItemProps) => {
  const { item: course }: any = useListItemDataProvider();
  const {
    name,
    emoji,
    custom_emoji_url: customEmojiUrl,
    custom_emoji_dark_url: customEmojiDarkUrl,
  } = course;
  const { currentAppearance } = useThemeContext();

  return (
    <div
      className={classNames("group flex gap-2 p-4", {
        "bg-primary border-primary border": isDragOverlay,
      })}
    >
      <div
        className={classNames(
          "group-hover:bg-secondary flex h-6 w-6 items-center justify-center rounded",
          { "bg-secondary": isDragOverlay },
        )}
      >
        <Icon type="16-reorder" size={16} />
      </div>
      <Typography.LabelMd truncate>
        <div className="flex min-w-0 items-center gap-x-1">
          <EmojiRenderer
            className="!h-6 !w-6"
            emoji={emoji}
            appearance={currentAppearance}
            customEmojiUrl={customEmojiUrl}
            customEmojiDarkUrl={customEmojiDarkUrl}
          />
          <span className="min-w-0 truncate">{name}</span>
        </div>
      </Typography.LabelMd>
    </div>
  );
};
